import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Card,
  Text,
  ButtonGroup,
  Button,
  Modal,
  TextField,
  Spinner,
  Toast,
  Select,
  FormLayout,
  Icon,
  Badge,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import MyPagination from "@material-ui/lab/Pagination";
import {
  CategoriesIcon,
  EditIcon,
  DeleteIcon,
  ArrowUpIcon,
  ArrowDownIcon,
} from "@shopify/polaris-icons";
import lebanonIcon from "../../../Assets/Images/lb.svg";
import iraqIcon from "../../../Assets/Images/iq.svg";
import egyptIcon from "../../../Assets/Images/eg.svg";
import { SaveMinor } from "@shopify/polaris-icons";
import { useParams, useNavigate } from "react-router-dom";

const ProjectsTaskManagerStatuses = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [search, setSearch] = useState("");
  const [channelFilter, setChannelFilter] = useState("All");
  const [country, setCountry] = useState("Lebanon");

  const [items, setItems] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 50;
  const refBoolPage = useRef(true);

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive(!active), []);
  const [toastContent, setToastContent] = useState("");

  const [modalActive, setModalActive] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [currentTitle, setCurrentTitle] = useState("");
  const [currentType, setCurrentType] = useState("");
  const [currentEditId, setCurrentEditId] = useState(null);

  const [deleteModalActive, setDeleteModalActive] = useState(false);
  const [currentDeleteId, setCurrentDeleteId] = useState(null);

  const handleModalToggle = useCallback(
    () => setModalActive(!modalActive),
    [modalActive]
  );
  const handleDeleteModalToggle = useCallback(
    () => setDeleteModalActive(!deleteModalActive),
    [deleteModalActive]
  );

  const handleAddItem = () => {
    setModalMode("add");
    setCurrentTitle("");
    setCurrentType("");
    setModalActive(true);
  };

  const handleEdit = (id, title, type) => {
    setModalMode("edit");
    setCurrentTitle(title || "");
    setCurrentType(type || "");
    setCurrentEditId(id);
    setModalActive(true);
  };

  const handleDelete = (id) => {
    setCurrentDeleteId(id);
    setDeleteModalActive(true);
  };

  const [isSaving, setIsSaving] = useState(false);

  const handleSaveName = async () => {
    let hasError = false;
    setTitleError("");
    setTypeError("");

    if (!currentTitle.trim()) {
      setTitleError("Title is required");
      hasError = true;
    }

    if (!currentType) {
      setTypeError("Type is required");
      hasError = true;
    }

    if (hasError) return;

    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("name", currentTitle);
    form_data.append("type", currentType);

    try {
      if (modalMode === "add") {
        await axios.post(`task-manager-projects/${id}/statuses`, form_data);
        setToastContent("Status added successfully");
      } else {
        form_data.append("_method", "PATCH");
        await axios.post(
          `task-manager-projects/${id}/statuses/${currentEditId}`,
          form_data
        );
        setToastContent("Status updated successfully");
      }
      toggleActive();
      fetchData();
      handleModalToggle();
    } catch (err) {
      console.error(err);
    }
    setIsSaving(false);
  };

  const confirmDelete = async () => {
    setIsSaving(true);
    try {
      await axios.delete(
        `/task-manager-projects/${id}/statuses/${currentDeleteId}`
      );
      setToastContent("Status deleted successfully");
      toggleActive();
      fetchData();
    } catch (err) {
      console.error(err);
    }
    setDeleteModalActive(false);
    setIsSaving(false);
  };

  const handleRowClick = (id) => {
    //navigate(`/admin/Categories/${id}/metrics`);
  };

  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleUp = (param) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .patch(`/task-manager-projects/${id}/statuses/${param}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (param) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .patch(`/task-manager-projects/${id}/statuses/${param}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const swithStatusColor = (value) => {
    switch (String(value)) {
      case "1":
        return `info`;
      case "2":
        return `warning`;
      case "3":
        return `success`;
      default:
        return "default";
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);
      if (search) params.append("filter[name]", search);

      const response = await axios.get(
        `/task-manager-projects/${id}/statuses`,
        { params }
      );
      const data = response.data.data.data;

      setItems(
        data.map((item) => [
          <div onClick={() => handleRowClick(item.id)} className="row_click">
            {item.name || "-"}
          </div>,
          <Badge tone={swithStatusColor(item.type.id)}>
            {item.type.description || "-"}
          </Badge>,
          <div className="me-3">
            <ButtonGroup>
              <Button onClick={() => handleUp(item.id)} size="slim">
                <Icon source={ArrowUpIcon}></Icon>
              </Button>
              <Button onClick={() => handleDown(item.id)} size="slim">
                <Icon source={ArrowDownIcon}></Icon>
              </Button>
              <Button
                onClick={() =>
                  handleEdit(item.id, item.name, String(item.type.id))
                }
                icon={EditIcon}
              >
                Edit
              </Button>
              <Button
                onClick={() => handleDelete(item.id)}
                icon={DeleteIcon}
                tone="critical"
                disabled={
                  String(item.type.id) === "1" &&
                  item.name.toLowerCase() === "backlog"
                }
              >
                Delete
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );

      setTotalPages(response.data.data.total);
      setIsListEmpty(!data.length);
    } catch (err) {
      console.error(err);
      setIsListEmpty(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [page, search, channelFilter, country]);
  const [titleError, setTitleError] = useState("");
  const [typeError, setTypeError] = useState("");
  return items ? (
    <Page
      title="Project Statuses"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem}>
          Add Status
        </Button>
      }
      backAction={{
        onAction: () => navigate(`/admin/task-manager/projects/${id}`),
      }}
    >
      {items?.length ? (
        <Card padding="0">
          <DataTable
            columnContentTypes={["text", "text", "text"]}
            headings={["Title", "Type", ""]}
            rows={items}
            verticalAlign="middle"
            stickyHeader
            footerContent={
              items?.length &&
              `Showing ${items.length} of ${totalPages} results`
            }
          />
        </Card>
      ) : (
        <Card>
          <div
            style={{
              display: "flex",
              justifyContent: "middle",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "25%" }}>
              <img src={emptyListImage}></img>
            </div>
            <div className="mb-3">
              <Text variant="headingLg" as="h5" color="subdued">
                No results found
              </Text>
            </div>
          </div>
        </Card>
      )}

      {Math.ceil(totalPages / perPage) >= 2 && (
        <MyPagination
          count={Math.ceil(totalPages / perPage)}
          page={page}
          onChange={handleChangePage}
          size="large"
        />
      )}

      {/* Add/Edit Modal */}
      <Modal
        open={modalActive}
        onClose={handleModalToggle}
        title={modalMode === "add" ? "Add Status" : "Edit Status"}
        primaryAction={{
          content: "Save",
          onAction: handleSaveName,
          loading: isSaving,
        }}
      >
        <Modal.Section>
          <FormLayout>
            <TextField
              label="Title"
              value={currentTitle}
              onChange={setCurrentTitle}
              autoComplete="off"
              placeholder="Enter title"
              error={titleError}
            />
            <Select
              label="Type"
              options={[
                { label: "Backlog", value: "1" },
                { label: "In Progress", value: "2" },
                { label: "Done", value: "3" },
              ]}
              value={currentType}
              onChange={setCurrentType}
              error={typeError}
              placeholder="Please select"
            />
          </FormLayout>
        </Modal.Section>
      </Modal>

      {/* Delete Modal */}
      <Modal
        open={deleteModalActive}
        onClose={handleDeleteModalToggle}
        title="Delete Status"
        primaryAction={{
          content: "Yes",
          destructive: true,
          onAction: confirmDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            onAction: handleDeleteModalToggle,
            loading: isSaving,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to delete this status?</Text>
        </Modal.Section>
      </Modal>

      {active && <Toast content={toastContent} onDismiss={toggleActive} />}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default ProjectsTaskManagerStatuses;
